export default {
  startRegisterResponse: state => {
    return state.startRegisterResponse;
  }
};
